export const toglePanel = (payload) => ({
    type: 'TOGGLE_PANEL',
    isPanelOpen: payload
});
